import { IAgentSourcedCreatorFilters } from '../types'

/**
 * True when the user has applied any attribute filter (platform, age, engagement,
 * followers, location, views, last-post). Sort settings are NOT filters, so they
 * are ignored — this lets the empty state distinguish "no matches for your
 * filters" from "no data yet".
 */
export const hasActiveFilters = (filters: IAgentSourcedCreatorFilters): boolean =>
  Boolean(
    filters.platforms?.length ||
      filters.age_ranges?.length ||
      filters.engagement_rate?.length ||
      filters.followers?.length ||
      filters.locations?.length ||
      filters.views?.length ||
      filters.last_post_within,
  )
